// assets
import {
    IconDashboard,
    IconBrandChrome,
    IconHelp,
    IconUsers,
    IconRoute,
    IconLayoutKanban,
    IconReport,
    IconSettings,
    IconSubtask,
    IconBuildingFactory,
    IconCurrencyRupee,
    IconCertificate
} from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconBrandChrome,
    IconHelp,
    IconUsers,
    IconRoute,
    IconLayoutKanban,
    IconReport,
    IconSettings,
    IconSubtask,
    IconBuildingFactory,
    IconCurrencyRupee,
    IconCertificate
};

// ==============================|| ADMIN MENU ITEMS ||============================== //

const routeExecutiveMenuItem = [
    // {
    //     id: 'dashboard',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'default',
    //             title: 'Dashboard',
    //             type: 'item',
    //             url: '/dashboard',
    //             icon: icons.IconDashboard,
    //             breadcrumbs: false
    //         }
    //     ]
    // },
    {
        id: 'main-pages',
        type: 'group',
        children: [
            {
                id: 'customers',
                title: 'Customers',
                type: 'collapse',
                icon: icons.IconUsers,
                breadcrumbs: false,
                children: [
                    {
                        id: 'customer-list',
                        title: 'List',
                        type: 'item',
                        url: '/customer-list',
                        breadcrumbs: false
                    }
                    // {
                    //     id: 'new-registration',
                    //     title: 'Register New Customer',
                    //     type: 'item',
                    //     url: '/customer-new-account',
                    //     breadcrumbs: false
                    // }
                ]
            },
            {
                id: 'routes',
                title: 'Routes & Collection',
                type: 'collapse',
                icon: icons.IconRoute,
                breadcrumbs: false,
                children: [
                    {
                        id: 'routes',
                        title: 'Manage Routes',
                        type: 'item',
                        url: '/routes',
                        breadcrumbs: false
                    },
                    {
                        id: 'route-schedule',
                        title: 'Route Schedule',
                        type: 'item',
                        url: '/route-schedule',
                        breadcrumbs: false
                    },
                    {
                        id: 'todays-routes',
                        title: 'Todays Routes',
                        type: 'item',
                        url: '/todays-routes',
                        breadcrumbs: false
                    },
                    {
                        id: 'rescanning',
                        title: 'Rescanning',
                        type: 'item',
                        url: '/rescanning',
                        breadcrumbs: false
                    }
                ]
            },
            {
                id: 'tasks',
                title: 'Tasks',
                type: 'item',
                url: '/tasks',
                icon: icons.IconSubtask,
                breadcrumbs: false
            }
        ]
    },
    // {
    //     id: 'accounts-pages',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'other',
    //             title: 'Accounts',
    //             type: 'item',
    //             url: '/accounts',
    //             icon: icons.IconCurrencyRupee,
    //             breadcrumbs: false
    //         }
    //     ]
    // },
    {
        id: 'setting-pages',
        type: 'group',
        children: [
            {
                id: 'admin',
                title: 'Settings',
                type: 'collapse',
                icon: icons.IconSettings,
                breadcrumbs: false,
                children: [
                    // {
                    //     id: 'rate-chart',
                    //     title: 'Areas & Rates',
                    //     type: 'item',
                    //     url: '/area-rates',
                    //     breadcrumbs: false
                    // },
                    // {
                    //     id: 'employee',
                    //     title: 'Employees',
                    //     type: 'item',
                    //     url: '/employee',
                    //     breadcrumbs: false
                    // },
                    {
                        id: 'drivers',
                        title: 'Drivers',
                        type: 'item',
                        url: '/drivers',
                        breadcrumbs: false
                    },
                    {
                        id: 'vehicles',
                        title: 'Vehicles',
                        type: 'item',
                        url: '/vehicles',
                        breadcrumbs: false
                    },
                    {
                        id: 'routeScheduleTemplates',
                        title: 'Route Schedule Templates',
                        type: 'item',
                        url: '/route-schedule-templates',
                        breadcrumbs: false
                    }
                ]
            },
            {
                id: 'reports',
                title: 'Reports',
                type: 'item',
                url: '/reports',
                icon: icons.IconReport,
                breadcrumbs: false
            },
            {
                id: 'data',
                title: 'Data',
                type: 'item',
                url: '/data',
                icon: icons.IconDatabase,
                breadcrumbs: false
            },
            {
                id: 'plant',
                title: 'Plant',
                type: 'collapse',
                icon: icons.IconBuildingFactory,
                breadcrumbs: false,
                children: [
                    {
                        id: 'vendor',
                        title: 'Vendors',
                        type: 'item',
                        url: '/vendors',
                        breadcrumbs: false
                    },
                    {
                        id: 'materials',
                        title: 'Materials',
                        type: 'item',
                        url: '/materials',
                        breadcrumbs: false
                    },
                    {
                        id: 'vendor-invoices',
                        title: 'Vendor Invoice',
                        type: 'item',
                        url: '/vendor-invoices',
                        breadcrumbs: false
                    },
                    {
                        id: 'vendor-payment',
                        title: 'Vendor Payments',
                        type: 'item',
                        url: '/vendor-payment',
                        breadcrumbs: false
                    },
                    {
                        id: 'etp-records',
                        title: 'ETP Records',
                        type: 'item',
                        url: '/etp-records',
                        breadcrumbs: false
                    },
                    {
                        id: '/chemical-disinfection-log-sheet',
                        title: 'Chemical Disinfection Log',
                        type: 'item',
                        url: '/chemical-disinfection-log-sheet',
                        breadcrumbs: false
                    },
                    {
                        id: '/shredding-material-log-sheet',
                        title: 'Shredding Material Log',
                        type: 'item',
                        url: '/shredding-material-log-sheet',
                        breadcrumbs: false
                    },
                    {
                        id: '/autoclave-log-sheet',
                        title: 'Autoclave Log',
                        type: 'item',
                        url: '/autoclave-log-sheet',
                        breadcrumbs: false
                    },
                    {
                        id: '/vehicle-tracking',
                        title: 'Vehicle Tracking',
                        type: 'item',
                        url: '/vehicle-tracking',
                        breadcrumbs: false
                    },
                    {
                        id: '/bmw-received-log-sheet',
                        title: 'BMW Received Log Sheets',
                        type: 'item',
                        url: '/bmw-received-log-sheet',
                        breadcrumbs: false
                    },
                    {
                        id: '/incineration-log-sheet',
                        title: 'Incineration Log Sheets',
                        type: 'item',
                        url: '/incineration-log-sheet',
                        breadcrumbs: false
                    }
                ]
            },
            {
                id: 'plant-reports',
                title: 'Plant Reports',
                type: 'item',
                url: '/plant-reports',
                icon: icons.IconReport,
                breadcrumbs: false
            }
        ]
    }
];

export default routeExecutiveMenuItem;
